import AxiosConfig from '../utils/AxiosConfig';

class EmailMarketingService {
  // Enviar correo de marketing (inmediato o programado)
  async sendEmail(emailData) {
    try {
      console.log('[EmailMarketingService] POST /marketing/send-email - Request:', {
        templateId: emailData.templateId,
        listId: emailData.listId,
        subject: emailData.subject,
        htmlContent: emailData.htmlContent ? `${emailData.htmlContent.substring(0, 50)}...` : '(vacío)',
        scheduled: emailData.scheduled,
        scheduledDate: emailData.scheduledDate || null
      });

      const response = await AxiosConfig.post('/marketing/send-email', emailData);
      
      console.log('[EmailMarketingService] POST /marketing/send-email - Response:', response.data);
      
      return response.data;
    } catch (error) {
      console.error('[EmailMarketingService] POST /marketing/send-email - Error:', error);
      console.error('[EmailMarketingService] POST /marketing/send-email - Error Response:', error.response?.data);
      throw error;
    }
  }

  // Obtener historial de envíos de correos
  async getEmailHistory(page = 1, pageSize = 10, searchTerm = '') {
    try {
      const params = new URLSearchParams({
        page: page.toString(),
        pageSize: pageSize.toString(),
        search: searchTerm && typeof searchTerm === 'string' ? searchTerm.trim() : ''
      });

      const response = await AxiosConfig.get(`/marketing/send-email?${params}`);
    
      const innerData = response.data?.data || response.data || {};
      const emailsArray = innerData.data || [];
      const total = innerData.total || 0;
      const currentPage = innerData.page !== undefined ? innerData.page : page;
      const currentPageSize = innerData.pageSize || pageSize;
      
      console.log('[EmailMarketingService] GET /marketing/send-email - Response:', {
        data: emailsArray,
        count: emailsArray.length,
        total: total,
        page: currentPage,
        pageSize: currentPageSize
      });
      
      // Retornar en formato consistente: { data: [...], total, page, pageSize }
      return {
        data: emailsArray,
        total: total,
        page: currentPage,
        pageSize: currentPageSize
      };
    } catch (error) {
      console.error('[EmailMarketingService] GET /marketing/send-email - Error:', error);
      console.error('[EmailMarketingService] GET /marketing/send-email - Error Response:', error.response?.data);
      throw error;
    }
  }

  // Actualizar un correo programado (solo si está en estado PENDING)
  async updateEmail(emailId, emailData) {
    try {
      console.log('[EmailMarketingService] PUT /marketing/send-email/' + emailId + ' - Request:', {
        templateId: emailData.templateId,
        listId: emailData.listId,
        subject: emailData.subject,
        htmlContent: emailData.htmlContent ? `${emailData.htmlContent.substring(0, 50)}...` : '(vacío)',
        scheduled: emailData.scheduled,
        scheduledDate: emailData.scheduledDate || null
      });

      const response = await AxiosConfig.put(`/marketing/send-email/${emailId}`, emailData);
      
      console.log('[EmailMarketingService] PUT /marketing/send-email/' + emailId + ' - Response:', response.data);
      
      return response.data;
    } catch (error) {
      console.error('[EmailMarketingService] PUT /marketing/send-email/' + emailId + ' - Error:', error);
      console.error('[EmailMarketingService] PUT /marketing/send-email/' + emailId + ' - Error Response:', error.response?.data);
      throw error;
    }
  }

  // Eliminar un correo programado (solo si está en estado PENDING)
  async deleteEmail(emailId) {
    try {
      console.log('[EmailMarketingService] DELETE /marketing/send-email/' + emailId + ' - Request');

      const response = await AxiosConfig.delete(`/marketing/send-email/${emailId}`);
      
      console.log('[EmailMarketingService] DELETE /marketing/send-email/' + emailId + ' - Response:', response.data);
      
      return response.data;
    } catch (error) {
      console.error('[EmailMarketingService] DELETE /marketing/send-email/' + emailId + ' - Error:', error);
      console.error('[EmailMarketingService] DELETE /marketing/send-email/' + emailId + ' - Error Response:', error.response?.data);
      throw error;
    }
  }
}

export default new EmailMarketingService();

